import { Create, Form, Input, Select, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ISample } from "types/sample.interface";
import { SampleSourceOptions } from "./utils";

export const SampleCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<ISample>();

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Track"
          name="track"
          rules={[
            {
              required: true,
              message: "Track is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: "Title is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Artist"
          name="artist"
          rules={[
            {
              required: true,
              message: "Artist is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Source"
          name="source"
          rules={[
            {
              required: true,
              message: "Source is required",
            },
          ]}
        >
          <Select options={SampleSourceOptions} />
        </Form.Item>

        <Form.Item
          label="Original Track Url"
          name="originalTrackUrl"
          rules={[
            {
              required: false,
              message: "Original Track Url is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
